import { useRef } from 'react';
import styles from './index.module.sass';
import TextInput from 'componets/text-input';
import iconInfo from 'images/icon-info.svg';
import { formatter } from 'helpers/rule-validation';

const BindCard = ({
  cardNumber,
  cardNumberErrorMessage,
  onChangeCardNumber,
  onFocusCardNumber,
  cardExpiredDate,
  cardExpiredDateErrorMessage,
  onChangeCardExpiredDate,
  onFocusCardExpiredDate,
  cardCVC,
  cardCVCErrorMessage,
  onChangeCardCVC,
  onFocusCardCVC,
  onSend,
}) => {
  const expiredDateRef = useRef('');
  const cvcRef = useRef('');

  return (
    <div className={styles.form}>
      <div className={styles['form-input']}>
        <TextInput
          inputmode="numeric"
          label="付款卡號"
          placeholder="信用卡或金融卡號碼"
          nextText={cardNumber}
          maxLength={19}
          errorMessage={cardNumberErrorMessage}
          onTextChange={value => {
            let formatValue = formatter(value, ' ', 4);
            onChangeCardNumber(formatValue);
            if (value.length === 19) {
              expiredDateRef.current.focus();
            }
          }}
          onFocus={onFocusCardNumber}
        />
      </div>
      <div className={styles['form-input']}>
        <TextInput
          ref={expiredDateRef}
          label="有效期限"
          placeholder="MM/YY"
          nextText={cardExpiredDate}
          maxLength={5}
          errorMessage={cardExpiredDateErrorMessage}
          onTextChange={value => {
            let formatValue = formatter(value, '/', 2);
            onChangeCardExpiredDate(formatValue);
            if (value.length === 5) {
              cvcRef.current.focus();
            }
          }}
          onFocus={onFocusCardExpiredDate}
        />
      </div>
      <div className={styles['form-input']}>
        <TextInput
          ref={cvcRef}
          label="CVC"
          placeholder="卡片背面末 3 碼"
          nextText={cardCVC}
          errorMessage={cardCVCErrorMessage}
          maxLength={3}
          onTextChange={onChangeCardCVC}
          onKeyPressEnter={onSend}
          onFocus={onFocusCardCVC}
        />
      </div>
      <div className={styles.hint}>
        <img src={iconInfo} alt="info" />
        新增卡片時將產生一筆台幣 1 元的過卡交易，不會實際請款，請安心！
      </div>
    </div>
  );
};

export default BindCard;
